import Swal from 'sweetalert2'
import CxltToastr from 'cxlt-vue2-toastr'

import {
	myhost
} from '@/modules/helping.js'

import axios from 'axios';
import router from '@/router';

export default {



	url1(){

return "https://moghavematyar.ir/api";
	},
	back() {
		router.go(-1)
	},


	host_test(){
		return "https://moghavematyar.ir/api";
	},
	success_swal2(text) {
		return Swal.fire({
			position: 'center',
			icon: 'success',
			title: text,
			showConfirmButton: true,
			confirmButtonText: 'تایید',
		})
	},
	success_swal() {


		return CxltToastr.error({
			title: 'با سپاس',
			message: 'نظر شما با موفقیت ثبت شد .',
			color: "#22a878"
		})

	},
	warn_swal(text) {
		return Swal.fire({
			position: 'center',
			icon: 'warning',
			title: text,
			showConfirmButton: false,
			timer: 2000
		})

	},

	error_swal(text) {
		return Swal.fire({
			position: 'center',
			icon: 'error',
			title: text,
			showConfirmButton: true,
			confirmButtonText: 'متوجه شدم',
			timer: 2000
		})

	},
	scroll_smoote() {
		return window.scrollTo({
			top: 0,
			behavior: 'smooth'
		});
	},


	state() {

		let self = this;
		return self;
	},

	imageHost() {
		return "https://moghavematyar.ir/api";
		//return "https://maghar.nickpars.ir/api3";
	},
	url() {
		return "https://moghavematyar.ir/api";
	},
	// imageHost() {
	// 	return "http://localhost/adminapi";
	// },

	LoginRoute() {
		location.href = '/login'

	},


	logoutreq() {
		axios.post(myhost + "/admin47/logouts").then(response => {
				//console.log(response.data);
				if (response.data.error === false) {
					router.push({
						path: "/login"
					})
				}

			})
			.catch(function (error) {
				console.log(error)

			});

	},

	url_image() {
		return "http://localhost/adminapi/files/images/";
	},



	url_part() {
		return "http://localhost/adminapi/education/";
	},


	url_image2() {
		return "http://localhost/adminapi/files/images/";
	},
	url_size() {
		return "?width=200&&height=200&&quality=80";
	},


	toFarsiNumber(n) {
		const farsiDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];

		return n
			.toString()
			.split('')
			.map(x => farsiDigits[x])
			.join('');
	},

/*************************** */
	create_token() {
		const rand = () => {
			return Math.random().toString(36).substr(2);
		};
		const token = () => {
			return rand() + rand();
		};
		return token()
	},
	set_token()
	{
		localStorage.setItem('porseshgah-token',this.create_token())
	},
	remove_token()
	{
		localStorage.removeItem('porseshgah-token');
	},
	get_token()
	{
		var token=localStorage.getItem('porseshgah-token')
		return token;
	},
	check_token() {
		if(this.get_token()==null)
		{
			this.set_token()
		}
	},

	get(url,json)
	{
	let response=	axios.post(url, {data: json	})
	return response;
	},


	loginroute() {
		router.push({
			path: "/login"
		})
	},


	
	async logouts2() {
		const self = this;
		await axios.post(self.host_test()+"/pan/logouts")
			.then(function (res) {
				//console.log(res);
				if (res.data.error === false) {
					router.push({
						path: "/login"
					})
				}
			})
			.catch(function (e) {
				console.log(e);
				location.reload();
			
				//
			});
	},
	checklogin2() {
		const self=this;
		axios.get(self.host_test()+'/pan/logincheck').then(response => {
				//console.log(response);
				if (response.data.error === true) {
					////console.log('must login');
					router.push({
						path: "/login"
					})

				} else {
					//console.log('loggined');
				}
			})
			.catch(function (error) {

				error;

			});

	},



	//	http://localhost/adminapi/files/images/f3e3e4af3360e7387fd1ebd2c1d0bf884e904efa.jpg?width=300&height=300&quality=50

	//	http://localhost/adminapi/files/images/f3e3e4af3360e7387fd1ebd2c1d0bf884e904efa.jpg



}